module.exports = __webpack_public_path__ + "static/media/bannerReports.7c5b8956.svg";